import { useState, useEffect } from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonialsAPI } from '@/lib/api';

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await testimonialsAPI.getAll();
        setTestimonials(response.data.slice(0, 6)); // Show top 6 testimonials
      } catch (error) {
        console.error('Failed to fetch testimonials:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchTestimonials();
  }, []);

  if (loading || testimonials.length === 0) {
    return null;
  }

  return (
    <section className="py-20 bg-gradient-to-b from-black to-[#121212]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-light text-white mb-4">
            نظرات <span className="text-[#D4AF37]">مشتریان</span>
          </h2>
          <p className="text-lg text-zinc-400">
            تجربه مشتریان ما در سفر به سوی آینده‌ای بهتر
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="glass-effect border border-white/10 rounded-2xl p-8 relative hover:border-[#D4AF37]/30 transition-all"
            >
              {/* Quote Icon */}
              <div className="absolute top-6 right-6 text-[#D4AF37] opacity-20">
                <Quote size={48} />
              </div>

              {/* Customer Image */}
              <div className="flex justify-center mb-6 relative z-10">
                {testimonial.image_url ? (
                  <img
                    src={testimonial.image_url}
                    alt={testimonial.name_fa}
                    className="w-20 h-20 rounded-full object-cover border-4 border-[#D4AF37]"
                  />
                ) : (
                  <div className="w-20 h-20 rounded-full bg-gradient-to-br from-[#D4AF37] to-[#F3E5AB] flex items-center justify-center text-white text-2xl font-bold border-4 border-[#D4AF37]">
                    {testimonial.name_fa.charAt(0)}
                  </div>
                )}
              </div>

              {/* Customer Info */}
              <div className="text-center mb-4">
                <h3 className="text-xl font-semibold text-white mb-1">{testimonial.name_fa}</h3>
                <p className="text-sm text-zinc-400">{testimonial.service_type}</p>
                <p className="text-xs text-[#D4AF37] mt-1">{testimonial.destination_country}</p>
              </div>

              {/* Rating */}
              <div className="flex justify-center gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={`star-${testimonial.id}-${i}`}
                    size={18}
                    className={i < testimonial.rating ? 'text-[#D4AF37] fill-[#D4AF37]' : 'text-zinc-700'}
                  />
                ))}
              </div>

              {/* Comment */}
              <p className="text-sm text-zinc-300 text-center leading-relaxed italic">
                "{testimonial.comment_fa}"
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
